import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';

/**
 * ═══════════════════════════════════════════════════════════════════════
 * СКОЛЬКО ЛЮДЕЙ И СКОЛЬКО ПИСЕМ ЖДЁТ — ДЛЯ ПОДПИСИ ПУНКТА МЕНЮ.
 *
 * Передача 10.09.2026 просит под пунктом «Участники и права» строку
 * «3 человека с доступом · 1 ждёт ответа».
 *
 * ТЕ ЖЕ КЛЮЧИ ЗАПРОСА, ЧТО У САМОГО ЭКРАНА (`['members', wsId]`,
 * `['invites', wsId]`). Заведи здесь свои — и `react-query` сходил бы
 * на сервер второй раз, а число в меню и число над списком разошлись бы
 * на время между двумя ответами.
 *
 * ЖИВУТ ОНИ ОТДЕЛЬНЫМ ФАЙЛОМ, а не в `members.page.tsx`, потому что
 * рамка кабинета грузится всегда, а экран участников — лениво: тяни
 * рамка хук из страницы, и весь её код приезжал бы человеку, который
 * на этот экран никогда не заходит.
 * ═══════════════════════════════════════════════════════════════════════
 */

/** Сколько людей с доступом, включая владельца. `null` — ответа ещё нет. */
export function useЧислоУчастников(wsId: string | undefined, enabled: boolean): number | null {
  const q = useQuery({
    queryKey: ['members', wsId],
    queryFn: () => api<{ members: unknown[] }>(`/workspaces/${wsId!}/members`),
    enabled: Boolean(wsId) && enabled,
    // Отказ молчит: пункт меню ведёт на экран и без числа.
    retry: false,
    staleTime: 60_000,
  });
  return q.data?.members.length ?? null;
}

/** Сколько приглашений ждёт ответа. При отказе число остаётся неизвестным. */
export function useЧислоПриглашений(wsId: string | undefined, enabled: boolean): number | null {
  const q = useQuery({
    queryKey: ['invites', wsId],
    queryFn: () => api<{ invites: unknown[] }>(`/workspaces/${wsId!}/invites`),
    enabled: Boolean(wsId) && enabled,
    retry: false,
    staleTime: 60_000,
  });
  return q.data?.invites.length ?? null;
}
